import { Schedules } from "./Schedules";
import { SchedulesAdd } from "./SchedulesAdd";
import { SchedulesEdit } from "./SchedulesEdit";

export {Schedules , SchedulesAdd , SchedulesEdit} ;